// External
import React, { Component } from "react";
import { connect } from "react-redux";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import Moment from "moment";
import { cloneDeep, debounce, isNull } from "lodash";

// Internal
import DraggableSiteRouteCrew from "../cards/DraggableSiteRouteCrew";
import DraggableShiftCanvasser from "../cards/DraggableShiftCanvasser";
import FilterDisplay from "../subscreens/FilterDisplay";
import {
  filterAndSortItems,
  handleSearchChange,
} from "../../utils/FilterDisplayUtils";
import {
  findCanvassersAssignedToShift,
  findCheckedInCanvassers,
} from "../../utils/schedulerUtils";

import api from "../../store/api/api";
import {
  createCrew,
  createCrewCanvasser,
  createShift,
  createShiftCanvasser,
  deleteCrew,
  deleteCrewCanvasser,
  getSchedule,
  pullCampaignCanvassers,
  pullCrews,
  pullSiteRoutes,
  updateCrew,
  updateShiftCanvasser,
} from "../../store/api/calls";

import {
  setCrews,
  setCrewsShiftData,
  setSessionVar,
} from "../../store/actions";

import NavBaseTemplate from "../templates/NavBaseTemplate";
import FeedbackTile from "../theme/modals/FeedbackTile";
import Tabs from "../theme/menus/Tabs";
import Input from "../theme/forms/Input";
import BaseModal from "../theme/modals/BaseModal";
import SiteNoteModal from "../theme/modals/SiteNoteModal";
import CanvasserFilters from "../subscreens/CanvasserFilters";

class Schedule extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      pageError: false,
      errMsg: "There was a server error",
      siteRoutes: [],
      crews: [],
      crewsDrop: [],
      displayedCanvassers: [],
      selectedDate: new Moment(Date.now()).format("YYYY-MM-DD"),
      sideBarSelection: "siteroutes",
      showAssignedCanvassers: true,
      hideSitesInRoutes: false,
      crewDropMatActive: false,
      availableCanvasserStatuses: [
        "checked_in",
        "not_checked_in",
        "unscheduled",
      ],
      displayedCanvasserStatuses: [
        "checked_in",
        "not_checked_in",
        "unscheduled",
      ],
      //crewsheets
      crewsheet_modal_show: false,
      crewsheet_crews: [],
      crewsheet_get_dirs: true,
      crewsheet_selected_shift_idx: 0,
      // shifts
      shiftData: [],
      shiftId: 0,
      showShiftModal: false,
      shiftStart: undefined,
      shiftEnd: undefined,
      invalidInput: false,
      invalidTime: false,
      shiftError: false,
      lockShiftSubmit: false,
      canvasserFilters: {
        id: "canvassers",
        keyword: "",
        keywordPersist: "",
        noteTags: [],
        sortBy: "lastname",
        sortDsc: false,
        searchFields: ["firstname", "lastname", "created_at"],
        sortFields: [
          {
            display: "Name",
            value: "lastname",
          },
          {
            display: "Creation Date",
            value: "created_at",
          },
          {
            display: "Status",
            value: "status",
          },
        ],
      },

      routeFilters: {
        id: "routes",
        keyword: "",
        keywordPersist: "",
        noteTags: [],
        sortBy: "siteroute_name",
        sortDsc: false,
        searchFields: ["siteroute_name"],
        sortFields: [
          {
            display: "Name",
            value: "siteroute_name",
          },
          {
            display: "Creation Date",
            value: "created_at",
          },
          {
            display: "Seat Count",
            value: "seat_count",
          },
        ],
      },
      focusedOffice: 0,
    };
    this.focusedSiteCanvass = 0;

    this.colorClassMapping = {
      checked_in: { class: "_green", color: "#33a02c" },
      not_checked_in: { class: "_red", color: "#e31a1c" },
      unscheduled: { class: "_grey", color: "darkgrey" },
      assigned: { class: "_blue", color: "#1f78b4" },
    };

    this.dateChangeTimeout = undefined;
  }

  componentDidMount() {
    if (this.props.focusedCampaign !== 0 && !this.props.focusedCampaign.id) {
      setTimeout(() => this.componentDidMount(), 200);
    } else {
      this.getDataOnLoad();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.dateChangeTimeout);
  }

  setError = (errMsg) => {
    this.setState({
      errMsg,
      pageError: true,
    });

    setTimeout(() => {
      this.setState({ pageError: false });
    }, 3000);
  };

  /*
   * Data currently comes in sets of shifts. We're not using that yet, so for the moment we just pull the list of assignedSites,
   * merge them in with the assignedSites object, and then we can show who is available.
   */
  getAndParseSchedule = () => {
    return getSchedule(this.state.focusedOffice, this.state.selectedDate).then(
      (data) => {
        let scs = [];
        let scsIds = [];

        data.forEach((d) => {
          d.canvassers.forEach((shift_canvasser) => {
            let c = this.props.canvassers.find(
              (item) => item.id === shift_canvasser.canvasser
            );
            if (c && !scsIds.includes(c.id)) {
              c.shift = shift_canvasser.shift;
              c.present = shift_canvasser.present;
              c.assigned = !isNull(shift_canvasser.crew);
              c.scheduled = shift_canvasser.scheduled;
              scs.push(c);
              scsIds.push(c.id);
            }
          });
        });

        let scheduled_ids = scs.length ? scs.map((_d) => _d.id) : [];
        let final = [
          ...scs,
          ...this.props.canvassers.filter((c) => !scheduled_ids.includes(c.id)),
        ];
        final = final.length ? final.map(this.setShiftCanvasserStatus) : [];
        console.log(`getAndParseSchedule`, final);
        final = final.filter((n) => n.office == this.state.focusedOffice);

        let shiftId = data[this.state.crewsheet_selected_shift_idx]
          ? data[this.state.crewsheet_selected_shift_idx].id
          : 0;

        this.setState({ displayedCanvassers: final, shiftData: data, shiftId });
      }
    );
  };

  setShiftCanvasserStatus = (d) => {
    if (d.scheduled && d.present) {
      d.status = "checked_in";
    } else if (d.scheduled && !d.present) {
      d.status = "not_checked_in";
    } else {
      d.status = "unscheduled";
    }

    //loop over crew and find out if the id is assigned
    let crewmembers = this.state.crews.reduce((acc, item, idx) => {
      let members = item.routeseats
        .filter((s) => !!s.canvasser_id)
        .map((s) => s.canvasser_id);
      acc = [...acc, ...members];
      return acc;
    }, []);

    if (crewmembers.includes(d.id)) {
      d.assigned = true;
    }
    return d;
  };

  getDataOnLoad() {
    this.setState({ loading: true });
    const {
      match: { params },
    } = this.props;
    this.focusedSiteCanvass = params.sitecanvass_id;
    let fullSiteCanvass = this.props.siteCanvasses.find(
      (d) => d.id === this.focusedSiteCanvass
    );
    if (fullSiteCanvass) this.state.focusedOffice = fullSiteCanvass.office;

    // Site canvass id will come from url params
    new Promise((resolve, reject) => {
      if (this.state.focusedOffice) {
        resolve();
      } else {
        return api
          .get(`/sitecanvasses/${this.focusedSiteCanvass}/`)
          .then((res) => {
            this.setState({
              focusedOffice: +res.data.office,
            });
            return resolve();
          })
          .catch((err) => {
            console.error(err);
            this.setState({
              pageError: true,
              errMsg: "Error loading Site Canvass Data",
              loading: false,
            });

            this.setState({ focusedOffice: 0 });
            return reject();
          });
      }
    })
      .then(() => {
        Promise.all([
          pullSiteRoutes(this.focusedSiteCanvass),
          pullCampaignCanvassers({
            // office: this.state.focusedOffice,
            abilities: 1,
          }),
          pullCrews({
            sitecanvass: params.sitecanvass_id,
            date: this.state.selectedDate,
          }),
        ])
          .then((data) => {
            return this.getAndParseSchedule().then((res) => {
              // crews correspond to the 3rd call in the promiseAll above.
              let crews = data[2] || [];
              let formed_crews = [];
              const { siteRoutes } = { ...this.props };

              let siteroutes = siteRoutes.map((item, index) => {
                return { ...item, routeseats: [...item.routeseats] };
              });

              this.setState({ siteRoutes: siteroutes });

              if (crews) {
                crews.forEach((crew) => {
                  let found_sr = siteRoutes.find(
                    (d) => d.siteroute_id === crew.siteroute && !crew.crew_id
                  );
                  if (found_sr) {
                    found_sr = cloneDeep(found_sr);
                    found_sr.crew_id = crew.id;
                    found_sr = { ...crew, ...found_sr };
                    // now assign assignedSites to seats

                    found_sr.routeseats.forEach((rs) => {
                      crew.canvassers.forEach((c) => {
                        if (rs.routeseat_id === c.routeseat_id) {
                          let {
                            crewcanvasser_id,
                            canvasser_id,
                            goal,
                            comments,
                            roles,
                          } = c;
                          rs.crewcanvasser_id = crewcanvasser_id;
                          rs.canvasser_id = canvasser_id;
                          rs.goal = goal;
                          rs.comments = comments;
                          rs.roles = roles || [];
                        }
                      });
                      rs.assignment_placeholder_note = (
                        crew.assignment_notes.find(
                          (d) =>
                            d.shift === crew.shift &&
                            d.routeseat === rs.routeseat_id
                        ) || {}
                      ).note;
                    });
                    formed_crews.push(found_sr);
                  }
                });
              }

              const deepclone_crew = cloneDeep(formed_crews);
              this.setState({
                siteRoutes,
                crews: deepclone_crew,
                loading: false,
              });
            });
          })
          // if we have a shift, then we need to make sure that it is properly set
          .then(() => {
            if (this.state.shiftData.length) {
              this.props.setCrewsShiftData(this.state.shiftData[0]);
            }
          })
          .catch((err) => {
            // Promise.all catch
            this.setState({
              loading: false,
              pageError: true,
              errMsg: "Error retrieving crew data.",
            });
          });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loading: false, pageError: true });
      });
  }

  //THIS FUNCTION HANDLES THE DROPPING OF A SITEROUTE INTO SCHEDULE TO CREATE A CREW
  onDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    document.getElementById("crew-drop-mat").className = "crew-drop-mat";
    document.getElementById("crewlist").className = "crewlist";

    // destination will be null when dropped outside of context or it ended up in same column and same index
    if (
      !destination ||
      (destination.droppableId === source.droppableId &&
        destination.index === source.index) ||
      this.state.shiftData.length === 0
    ) {
      this.setState({ crewDropMatActive: false });
      return;
    }

    const drop_is_seat_assignment =
      destination.droppableId.includes("routeseat-assign");

    // now need to reorder.
    const start = this.state[source.droppableId];

    let endId;
    if (destination.droppableId === "crewsDrop" || drop_is_seat_assignment) {
      endId = "crews";
    } else {
      endId = destination.droppableId;
    }

    let end = this.state[endId];

    if (start === end) {
      const newColumnIds = Array.from(start);
      let spliced = newColumnIds.splice(source.index, 1);
      if (spliced.length > 0) {
        newColumnIds.splice(destination.index, 0, spliced[0]);
      }

      const newState = {
        ...this.state,
        crewDropMatActive: false,
        [destination.droppableId]: newColumnIds,
      };

      this.setState(newState);

      return;
    }

    //handle canvasser seat assignment
    if (drop_is_seat_assignment) {
      if (destination.droppableId === "crewsDrop") return; // assignedSites can't be crews

      let target_canvasser_id = draggableId.split("_")[1];
      let target_seat_id = destination.droppableId.match(
        /routeseat-assign_(\d+)/
      )[1];
      let target_crew_id = destination.droppableId.match(/_crew_(\d+)/)[1];

      //check if seat is already assigned

      this._handleCanvasserSelect(
        target_crew_id,
        target_seat_id,
        target_canvasser_id
      );
      return;
    }

    // move from one list to another. This is used for moving siteroutes to scheduled crews.
    console.log("start", start);
    const newStart = Array.from(start);
    const newFinish = Array.from(end);

    console.log(newStart);
    // let item = newStart.slice(source.index, source.index + 1);
    let item = newStart.find((d) => d.siteroute_id === +draggableId);

    if (item) {
      newFinish.splice(destination.index, 0, { ...item });
    }

    const newState = {
      ...this.state,
      crewDropMatActive: false,
      [source.droppableId]: start,
      [endId]: newFinish,
    };

    if (source.droppableId === "siteRoutes") {
      if (!this.state.shiftId) {
        // Shifts must exist by this point and if they don't something is wrong.
        return;
      }

      // Need to do api call to preserve new crew and then call setState in then
      console.log(item);
      let requestData = {
        siteroute: item.siteroute_id,
        canvass_date: this.state.selectedDate,
        shift: this.state.shiftId,
      };
      console.log(requestData);

      this.setState({ loading: true });
      createCrew(requestData).then((crew) => {
        newState.crews.forEach((d) => {
          if (d.siteroute_id === crew.siteroute && !d.crew_id) {
            d.shift = crew.shift;
            d.crew_id = crew.id;
          }
        });
        newState.loading = false;
        this.setState(newState);
      });
      return;
    } else {
      this.setState(newState);
    }
  };

  updateOrCreateShiftCanvasser(canvasser_id, crew_id) {
    // Search through shift data assignedSites to see if they already exist, and if so update, else create them.
    let exists = false;

    this.state.displayedCanvassers.length &&
      this.state.displayedCanvassers.forEach((canvasser) => {
        if (canvasser.id === +canvasser_id && canvasser.shift) {
          exists = true;
        }
      });

    const updateState = (shiftCanvData) => {
      let newCanvList = [...this.state.displayedCanvassers];
      newCanvList.forEach((d) => {
        if (
          d.id === +shiftCanvData.canvasser &&
          d.shift === +shiftCanvData.shift
        ) {
          d.assigned = !isNull(shiftCanvData.crew);
        }
      });
      this.setState({ displayedCanvassers: newCanvList });
    };

    if (exists) {
      updateShiftCanvasser({
        canvasser: canvasser_id,
        shift: this.state.shiftId,
        crew: crew_id,
      }).then(updateState);
    } else {
      // create a shift canvasser so other sitecanvasses can see this person was scheduled.
      createShiftCanvasser({
        canvasser: canvasser_id,
        shift: this.state.shiftId,
        crew: crew_id,
        scheduled: false,
        present: false,
      }).then(updateState);
    }
  }

  // note, to create a crewcanvasser, you can leave that argument null
  _handleCanvasserSelect = (
    crew_id,
    routeseat_id,
    canvasser_id,
    crewcanvasser_id,
    _delete = false
  ) => {
    let crewcanvassers_to_delete = [];

    let update_cols = (data) => {
      let crews = cloneDeep(this.state.crews);
      let siteRoutes = cloneDeep(this.props.siteRoutes);
      crews.forEach((c) => {
        if (+c.crew_id === +data.crew) {
          //loop through routeseats
          let routeSeats = cloneDeep(c.routeseats);
          c.routeseats = routeSeats.map((d) => {
            console.log(d, canvasser_id, "deleting");
            if (+d.routeseat_id === +routeseat_id) {
              // first is there already a canvaasser there?
              d.crewcanvasser_id &&
                crewcanvassers_to_delete.push(d.crewcanvasser_id);
              d.canvasser_id = data.canvasser;
              d.crewcanvasser_id = data.id;
              d.goal = data.goal;
              d.comments = data.comments;
              d.roles = [];
            } else if (+d.canvasser_id === +canvasser_id) {
              crewcanvassers_to_delete.push(d.crewcanvasser_id);
              d.canvasser_id = null;
              d.crewcanvasser_id = null;
              d.goal = null;
              d.comments = null;
              d.roles = [];
            }
            return d;
          });
        }
      });
      this.setState({ siteRoutes, crews });
    };

    if (!_delete) {
      this.setState({ loading: true });
      return createCrewCanvasser({
        crew: crew_id,
        routeseat: routeseat_id,
        canvasser: canvasser_id,
      })
        .then((data) => {
          //update in the column
          update_cols(data);
          this.setState({ loading: false });
          if (crewcanvassers_to_delete.length) {
            crewcanvassers_to_delete.forEach((d) => {
              return deleteCrewCanvasser(d);
            });
          }
        })
        .then(() => {
          // sync who has been assigned across site canvasses
          this.updateOrCreateShiftCanvasser(canvasser_id, crew_id);
        });
    } else {
      if (crewcanvasser_id) {
        this.setState({ loading: true });
        return deleteCrewCanvasser(crewcanvasser_id).then(() => {
          // remove the shift canvasser's reference to the crew so other sitecanvasses know they are not scheduled.
          this.updateOrCreateShiftCanvasser(canvasser_id, null);
          update_cols(
            { crew: crew_id, routeseat_id, canvasser: null, id: null },
            true
          );
          this.setState({ loading: false });
        });
      } else {
        return new Promise((resolve) => {});
      }
    }
  };

  _handleDeleteCrew = (id) => {
    this.setState({ loading: true });
    deleteCrew(id).then(() => {
      this.setState({
        crews: this.state.crews.filter((d) => d.crew_id !== id),
        loading: false,
      });
    });
  };

  _handleFilterTextChange = (val) => {
    // once typing begins, clear the value we persist when moving away from the filter input.
    this.setState({
      persistFilterValue: "",
      filterText: val.trim().toLowerCase(),
    });
  };

  buildRoutesToDisplay() {
    return filterAndSortItems(this.state.siteRoutes, this.state.routeFilters);
  }

  _renderUnassignedRoutes(finalList) {
    return (
      <Droppable
        droppableId="siteRoutes"
        style={{ minHeight: "100px", minWidth: "10rem", width: "100%" }}
      >
        {(provided) => (
          <div
            ref={provided.innerRef}
            style={{ minHeight: "100px", minWidth: "10rem", width: "100%" }}
          >
            {finalList.map((item, index) => {
              return (
                <DraggableSiteRouteCrew
                  key={item.name + "-" + item.siteroute_id}
                  index={index}
                  id={`site-card-${item.siteroute_id}`}
                  name={item.siteroute_name}
                  draggableId={`${item.siteroute_id}`}
                  color={item.hex_color}
                  availableRoute={true}
                  routeseats={item.routeseats}
                />
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    );
  }

  buildCanvassersToDisplay() {
    // start by getting an array of assigned assignedSites so that we can mark them

    let assigned_canvassers = findCanvassersAssignedToShift(
      this.state.crews,
      this.state.shiftId
    );

    console.log("ASSIGNED CANVASSERS", assigned_canvassers);

    //we have a duping problem. Curing the symptom and not the disease here by filtering out for dupes.
    let dedupedDisplayedCanvassers = [];
    let dedupedIDCheck = [];
    this.state.displayedCanvassers &&
      this.state.displayedCanvassers.length &&
      this.state.displayedCanvassers.forEach((d) => {
        d.assigned = assigned_canvassers.includes(d.id);
        if (dedupedIDCheck.indexOf(d.id) === -1) {
          dedupedIDCheck.push(d.id);
          dedupedDisplayedCanvassers.push(d);
        }
      });

    const finalList = filterAndSortItems(
      dedupedDisplayedCanvassers,
      this.state.canvasserFilters
    )
      .filter((d) => this.state.displayedCanvasserStatuses.includes(d.status))
      .filter((d) =>
        this.state.showAssignedCanvassers
          ? true
          : !assigned_canvassers.includes(d.id)
      );

    return finalList;
  }

  _renderScheduledCanvassers(finalList) {
    return (
      <Droppable
        droppableId="displayedCanvassers"
        style={{ minHeight: "100px", minWidth: "10rem", width: "100%" }}
      >
        {(provided) => (
          <div
            ref={provided.innerRef}
            style={{ minHeight: "100px", minWidth: "10rem", width: "100%" }}
          >
            {finalList.map((item, index) => (
              <DraggableShiftCanvasser
                key={item.lastname + "-" + item.id}
                index={index}
                id={`canvasser-card-${item.id}`}
                name={item.firstname + " " + item.lastname}
                canvasser={item}
                draggableId={`canvasser_${item.id}`}
                color={this.colorClassMapping[item.status].color}
                assigned={item.assigned}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    );
  }

  _renderCrews = () => {
    let hasShifts = this.state.shiftData.length > 0;
    let dropMatMessage = hasShifts
      ? "Drag a crew over to start scheduling"
      : "Create a shift before adding routes.";

    let placeholderMessage =
      this.state.shiftData.length > 0
        ? "Drag to add a route"
        : "Create a shift first";

    let crews = cloneDeep(this.state.crews);
    crews = crews.filter((crew) => crew.shift === this.state.shiftId);

    return (
      //expanding droppable to enter crews. then moved over to the state object
      <>
        {/*  WARNING TO BUILD CREW SHEETS IF ROUTE TO ALL SITES IS TRUE */}

        {!!this.state.crews.some((d) => d.route_to_all_sites) && (
          <>
            <div className={"crew-warning-card"}>
              <div className={"flx align_center"}>
                <i className="fas fa-exclamation-triangle fa-2x mx-5" />
                <p className={"m-0"}>
                  In order to ensure that sites are canvassers are properly
                  routed between the sites on the mobile app, be sure to{" "}
                  <b>build your crewsheet before they log in</b>. Otherwise,
                  they will have to refresh their data on the phone to get the
                  correct routing order.
                </p>
              </div>
            </div>
          </>
        )}

        <Droppable droppableId="crewsDrop">
          {(provided) => (
            <div
              ref={provided.innerRef}
              id="crew-drop-mat"
              className={`crew-drop-mat`}
            >
              <div
                className={`drop-text-wrapper ${hasShifts ? "" : "warning"}`}
              >
                <div className="drop-text-plus">{hasShifts ? "+" : "x"}</div>
                <div className="drop-text-sub">{placeholderMessage}</div>
              </div>
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        <div className={"crewlist"} id="crewlist">
          {crews.length ? (
            crews.map((item, index) => {
              return (
                <DraggableSiteRouteCrew
                  key={
                    item.siteroute_name + "-" + item.siteroute_id + item.crew_id
                  }
                  index={index}
                  crew_id={item.crew_id}
                  id={`site-card-${item.crew_id}`}
                  name={item.siteroute_name}
                  color={item.hex_color}
                  draggableId={`crew-${item.crew_id}`}
                  routeseats={item.routeseats}
                  sitecanvass={this.focusedSiteCanvass}
                  sr_data={item}
                  availableRoute={false}
                  displaySites={!this.state.hideSitesInRoutes}
                  draggable={true}
                  canvassers={this.props.canvassers}
                  getParentState={() => ({ ...this.state })} // do not change this to be a property, or any cahnge in parent state will force rerender of child
                  setParentState={(obj) => this.setState(obj)}
                  cardInDraggableContext={false} //if it's outside a draggable, then make element not dragganble. Otherwise will not render
                  onCanvasserSelect={(
                    canvasser_id,
                    routeseat_id,
                    crewcanvasser_id,
                    _delete
                  ) => {
                    this._handleCanvasserSelect(
                      item.crew_id,
                      routeseat_id,
                      canvasser_id,
                      crewcanvasser_id,
                      _delete
                    );
                  }}
                  onDeleteClick={() => this._handleDeleteCrew(item.crew_id)}
                  onCrewCanvasserChange={(seat_data) =>
                    this._handleCrewCanvasserChange(item.crew_id, seat_data)
                  }
                  //mostly used for DTS, and only works on routes with one seat. Basically, tells crewsheets to build a routeplan that goes to every site in the route
                  onRouteToAllSitesToggle={() =>
                    this._handleRouteToAllSitesToggle(item.crew_id)
                  }
                />
              );
            })
          ) : (
            <div className={`empty-drop-mat`}>
              {!this._isLoading() && dropMatMessage}
            </div>
          )}
        </div>
      </>
    );
  };

  _handleCrewCanvasserChange = (crew_id, seat_data) => {
    let crews = cloneDeep(this.state.crews);
    let crew_index = crews.findIndex((d) => d.crew_id === +crew_id);
    if (crew_index < 0) {
      console.warn(
        "Tried to update a crew, but none found that match id ",
        crew_id
      );
      return;
    }

    let seat_index = crews[crew_index].routeseats.findIndex(
      (d) => d.crewcanvasser_id === +seat_data.crewcanvasser_id
    );
    if (seat_index > -1) {
      crews[crew_index].routeseats[seat_index] = seat_data;
      this.setState({ crews });
    } else {
      console.warn(
        "Tried to update a crewcanvasser, but none found that matches id ",
        seat_data.crewcanvasser_id
      );
    }
  };

  _handleRouteToAllSitesToggle = (crew_id) => {
    let crews = cloneDeep(this.state.crews);
    let crew_index = crews.findIndex((d) => d.crew_id === +crew_id);
    if (crew_index < 0) {
      console.warn(
        "Tried to update a crew, but none found that match id ",
        crew_id
      );
      return;
    }

    const route_to_all_sites = !crews[crew_index].route_to_all_sites;

    crews[crew_index].route_to_all_sites = route_to_all_sites;

    updateCrew(crew_id, { route_to_all_sites })
      .then(() => {
        this.setState({ crews });
      })
      .catch(() => {
        this.setError("Unable to update the crew.");
      });
  };

  createNewShift() {
    this.setState({ lockShiftSubmit: true });
    // TODO: the create will 500 if focusedOffice is 0, or so it seems
    const data = {
      office: this.state.focusedOffice,
      start: this.state.shiftStart,
      end: this.state.shiftEnd,
      date: this.state.selectedDate,
    };

    let timeResult = this.buildStrictTimeString(data);

    if (!timeResult.strictEnd || !timeResult.strictStart) {
      this.setState({ invalidInput: true, lockShiftSubmit: false });
      return;
    }

    if (!this.checkValidRange(timeResult.strictStart, timeResult.strictEnd)) {
      this.setState({ invalidTime: true, lockShiftSubmit: false });
      return;
    }

    data.start = timeResult.strictStart;
    data.end = timeResult.strictEnd;

    createShift(data).then((data) => {
      if (data) {
        let shifts = this.state.shiftData.slice();
        shifts.push(data);
        this.props.setCrewsShiftData(data);
        this.setState({
          shiftData: shifts,
          shiftSuccess: true,
          showShiftModal: false,
          lockShiftSubmit: false,
          shiftId: data.id,
        });
        setTimeout(() => this.setState({ shiftSuccess: false }), 6000);
      } else {
        this.setState({
          shiftError: true,
          showShiftModal: false,
          lockShiftSubmit: false,
        });
        setTimeout(() => this.setState({ shiftError: false }), 6000);
      }
    });
  }

  // getting a string time format to send to the db
  buildStrictTimeString(data) {
    let strictStart;
    let strictEnd;

    const cleanInput = (str) => str.replace(/\s/g, "").toLowerCase();
    const _start = cleanInput(data.start);
    const _end = cleanInput(data.end);

    // This regex has 3 capture groups to get each sensical piece of time to reconstruct.
    let startPieces = _start.match(
      /^0*(0?[1-9]|1[012]{1,2}):([0-5]\d)\d*([ap]m)$/
    );
    let endPieces = _end.match(/^0*(0?[1-9]|1[012]{1,2}):([0-5]\d)\d*([ap]m)$/);

    if (startPieces && endPieces) {
      strictStart = startPieces[1] + ":" + startPieces[2] + startPieces[3];
      strictEnd = endPieces[1] + ":" + endPieces[2] + endPieces[3];
    }

    return { strictStart, strictEnd };
  }

  checkValidRange(start, end) {
    return Moment(start, "hh:mma").isBefore(Moment(end, "hh:mma"));
  }

  _validateDateTime(data) {
    let valid = false;
    let validRange = false;
    let strictStart;
    let strictEnd;

    const cleanInput = (str) => str.replace(/\s/g, "").toLowerCase();

    if (!data.start || !data.end) {
      this.setState({ invalidInput: !valid });
      return valid;
    }

    const _start = cleanInput(data.start);
    const _end = cleanInput(data.end);

    valid = Moment(_start, "hh:mma", true).isValid();
    valid = Moment(_end, "hh:mma", true).isValid();
    validRange = Moment(_start, "hh:mma").isBefore(Moment(data.end, "hh:mma"));

    if (!valid) {
      this.setState({ invalidInput: !valid });
    } else if (!validRange) {
      // start was after end, not allowed.
      this.setState({ invalidTime: !validRange });
      valid = false;
    } else {
      // moment is lax with time values, so only capture and set the exact digits we want if it's valid.
      // ie: 009:1811am is a valid time to moment despite the hh:mma format above. Don't submit that shift
      // This regex has 3 capture groups to get each sensical piece of time to reconstruct w/o the extra things moment allows.
      let startPieces = _start.match(
        /^0*(0?[1-9]|1[012]{1,2}):([0-5]\d)\d*([ap]m)$/
      );
      let endPieces = _end.match(
        /^0*(0?[1-9]|1[012]{1,2}):([0-5]\d)\d*([ap]m)$/
      );

      if (startPieces && endPieces) {
        strictStart = startPieces[1] + ":" + startPieces[2] + startPieces[3];
        strictEnd = endPieces[1] + ":" + endPieces[2] + endPieces[3];
      } else {
        // in the event the user has done something really wild and it got past moment, but failed the regex
        // send it back the user to fix.
        this.setState({ invalidInput: true });
        valid = false;
      }
    }

    return { valid, strictStart, strictEnd };
  }

  _handleTimeChange(key, val) {
    this.setState({
      [key]: val.trim(),
      invalidInput: false,
      invalidTime: false,
    });
  }

  _renderCreateShiftModal() {
    return (
      <BaseModal
        className=""
        open={this.state.showShiftModal}
        onClose={() => this.setState({ showShiftModal: false })}
        center
      >
        <div className="container">
          <i
            className="fas fa-pull-right fa-times"
            style={{ cursor: "pointer" }}
            onClick={() => this.setState({ showShiftModal: false })}
          />
          <h4 className={"primary-text"}>
            Create A Shift{" "}
            <span style={{ fontSize: ".7em" }}>
              ({this.state.selectedDate})
            </span>
          </h4>
          <span className={"secondary-text"}>Start Time </span>
          <span style={{ fontSize: ".7em" }}>(ie: 10:30am)</span>
          <Input
            type="text"
            placeholder={"10:30am"}
            onChange={this._handleTimeChange.bind(this, "shiftStart")}
          />
          <span className={"secondary-text"}>End Time </span>
          <span style={{ fontSize: ".7em" }}>(ie: 5:00pm)</span>
          <Input
            type="text"
            placeholder={"5:00pm"}
            onChange={this._handleTimeChange.bind(this, "shiftEnd")}
          />
          {this.state.invalidInput ? (
            <div
              style={{
                fontSize: ".8em",
                fontWeight: "bold",
                marginBottom: "1em",
              }}
            >
              <div className="danger-text"> Invalid Date / Time</div>
              Please make sure your times are correct. <br />
              See time format hints for help.
            </div>
          ) : null}
          {this.state.invalidTime ? (
            <div
              style={{
                fontSize: ".8em",
                fontWeight: "bold",
                marginBottom: "1em",
              }}
            >
              <div className="danger-text"> End must be after start time.</div>
            </div>
          ) : null}
          <button
            disabled={
              !this.state.shiftStart ||
              !this.state.shiftEnd ||
              this.state.lockShiftSubmit
            }
            className={`button button-outline text-primary`}
            onClick={this.createNewShift.bind(this)}
          >
            Submit
          </button>
        </div>
      </BaseModal>
    );
  }

  _changeDate = (add = true) => {
    //new Moment(Date.now()).format('YYYY-MM-DD')
    let { selectedDate } = this.state;
    let mom = new Moment(selectedDate, "YYYY-MM-DD");

    if (add) {
      mom = mom.add(1, "days");
    } else {
      mom = mom.subtract(1, "days");
    }

    let formatted_mom = mom.format("YYYY-MM-DD");
    this.setState(
      { selectedDate: formatted_mom, shiftId: 0 },
      this._setDateChangeTimeout
    );
  };

  _setDateChangeTimeout() {
    clearTimeout(this.dateChangeTimeout);
    this.dateChangeTimeout = setTimeout(() => this.getDataOnLoad(), 750);
  }

  _isLoading = () => {
    return (
      (this.props.siteroutes_loading ||
        this.props.canvassers_loading ||
        this.state.loading) &&
      !this._isError()
    );
  };

  _isError = () => {
    return (
      this.props.canvassers_error ||
      this.props.siteroutes_error ||
      this.state.shiftError ||
      this.state.pageError
    );
  };

  _buildCrewSheetModal = () => {
    this.props.setCrewsForRouting(
      this.state.crews.filter(
        (d) =>
          this.state.crewsheet_crews.includes(d.crew_id) &&
          d.shift === this.state.shiftId
      )
    );

    // reset all the sessionVars on build

    return (
      <BaseModal
        open={true}
        onClose={() => this.setState({ crewsheet_modal_show: false })}
        center
        title={"Build Crew Sheet"}
      >
        <div className="build-crew-sheet-modal-wrapper">
          <div className={"modal-section"}>
            <Input
              type={"switch-left"}
              checked={!this.props.sessionVars.hideDrivingDirections}
              defaultChecked={true}
              onChange={() => {
                this.props.setSessionVar(
                  "hideDrivingDirections",
                  !this.props.sessionVars.hideDrivingDirections
                );
              }}
              title={<b>Print Driving Directions</b>}
            />
            <Input
              type={"switch-left"}
              checked={!this.props.sessionVars.hideTravelPaths}
              defaultChecked={true}
              onChange={() => {
                this.props.setSessionVar(
                  "hideTravelPaths",
                  !this.props.sessionVars.hideTravelPaths
                );
              }}
              title={"Show Travel Paths"}
            />
          </div>
          <div className={"modal-section"}>
            <div className={"flx"}>
              <h5 className={"primary-text"} style={{ marginBottom: 0 }}>
                Filter Crews
              </h5>
              <div className={"ml-6"}>
                <div
                  className="button button-clear "
                  onClick={() => {
                    this.props.setSessionVar(
                      "excludedCrews",
                      this.state.crews.map((d) => d.crew_id)
                    );
                  }}
                >
                  Deselect All
                </div>
                <div
                  className="button button-clear px-0 ml-3"
                  // style={{ marginLeft: "1em" }}
                  onClick={() => {
                    this.props.setSessionVar("excludedCrews", []);
                  }}
                >
                  Select All
                </div>
              </div>
            </div>
            {this.state.crews.map((d) => {
              if (
                this.state.shiftData.length > 0 &&
                d.shift === this.state.shiftId
              ) {
                return (
                  <Input
                    type={"switch-left"}
                    key={d.crew_id}
                    checked={
                      !this.props.sessionVars.excludedCrews.includes(d.crew_id)
                    }
                    defaultChecked={true}
                    onChange={() => {
                      let { excludedCrews } = this.props.sessionVars;
                      if (
                        this.props.sessionVars.excludedCrews.includes(d.crew_id)
                      ) {
                        excludedCrews = excludedCrews.filter(
                          (c) => c !== d.crew_id
                        );
                      } else {
                        excludedCrews = [...excludedCrews, d.crew_id];
                      }
                      this.props.setSessionVar("excludedCrews", excludedCrews);
                    }}
                    title={d.siteroute_name}
                    style={{ padding: "5px", marginBottom: "5px" }}
                    classNames={"no-padding no-margin"}
                  />
                );
              }
            })}
          </div>
          <div className={"modal-section"}>
            <a
              href={"/site-crewsheet/" + this.props.shift_data.id}
              target={"_blank"}
            >
              <div
                onClick={() => this.setState({ crewsheet_modal_show: false })}
                className={"button"}
              >
                Print Crew Sheets
              </div>
            </a>
            <div
              className={"button button-outline"}
              style={{ marginLeft: "1em" }}
              onClick={() => this.setState({ crewsheet_modal_show: false })}
            >
              Cancel
            </div>
          </div>
        </div>
      </BaseModal>
    );
  };

  /**
   * _buildPrintShiftOptions()
   * - only allow shifts that have crews scheduled to be selected to print.
   * Otherwise, you could chose to print and unscheduled shift, and the crewsheet will never leave the load screen.
   *
   **/
  _buildPrintShiftOptions() {
    let crewShiftIds = this.state.crews.map((crew) => crew.shift);
    let shifts = this.state.shiftData.filter((shift) =>
      crewShiftIds.includes(shift.id)
    );
    return shifts.map((d, i) => ({
      value: i,
      display:
        new Moment(`${d.shift_date} ${d.start_time}`).format("hh:mma") +
        " - " +
        new Moment(`${d.shift_date} ${d.end_time}`).format("hh:mma"),
    }));
  }

  _handleOfficeChange = (val) => {
    console.log("HERE");
    this.setState(
      {
        focusedOffice: +val,
      },
      this.getAndParseSchedule
    );
  };

  _handleShiftChange(val) {
    const shiftDataIndex = this.state.shiftData.findIndex((d) => d.id === +val);
    let shiftData = {};
    if (shiftDataIndex > -1) shiftData = this.state.shiftData[shiftDataIndex];
    this.props.setCrewsShiftData(shiftData);

    // const shiftData = this.state.shiftData.length
    //   ? this.state.shiftData[+val]
    //   : {};
    // this.props.setCrewsShiftData(shiftData);

    this.setState({
      crewsheet_selected_shift_idx: shiftDataIndex,
      shiftId: +val,
    });
  }

  _loadCrewSheetModal = () => {
    this.props.setSessionVar("excludedCrews", []);
    this.props.setSessionVar("hideDrivingDirections", false);
    this.props.setSessionVar("hideTravelPaths", false);
    this.setState({
      crewsheet_modal_show: true,
      crewsheet_crews: this.state.crews.map((d) => d.crew_id),
    });
  };

  _handlePrintCrewSheetsRequest = () => {
    window.open(`/crewsheet/${this.props.shift_data.id}`, "_blank");
  };

  render() {
    let shiftCrews = this.state.crews;

    let routeValue =
      this.state.routeFilters.keywordPersist !== ""
        ? { value: this.state.routeFilters.keyword }
        : { test: 1 };

    let canvasserValue =
      this.state.canvasserFilters.keywordPersist !== ""
        ? { value: this.state.canvasserFilters.keyword }
        : { test: 1 };

    const debouncedCanvasserSearch = debounce((query) => {
      const stateChanges = handleSearchChange(query);
      this.setState(
        {
          ...stateChanges[0],
          canvasserFilters: {
            ...this.state.canvasserFilters,
            keyword: stateChanges[1],
          },
        },
        () =>
          filterAndSortItems(this.props.canvassers, this.state.canvasserFilters)
      );
    }, 300);

    const debouncedRouteSearch = debounce((query) => {
      const stateChanges = handleSearchChange(query);
      this.setState(
        {
          ...stateChanges[0],
          routeFilters: {
            ...this.state.routeFilters,
            keyword: stateChanges[1],
          },
        },
        () => filterAndSortItems(this.state.siteRoutes, this.state.routeFilters)
      );
    }, 300);

    if (this.state.shiftId) {
      shiftCrews = this.state.crews.filter(
        (crew) => crew.shift === this.state.shiftId
      );
    }

    const finalList =
      this.state.sideBarSelection === "siteroutes"
        ? this.buildRoutesToDisplay()
        : this.buildCanvassersToDisplay();

    return (
      <NavBaseTemplate
        location={this.props.location}
        history={this.props.history}
        disabled={true}
        showAdmin={this.props.is_admin}
      >
        <SiteNoteModal showCloseIcon center />
        <DragDropContext onDragEnd={this.onDragEnd}>
          <div className="flx space_between align_base schedule-title-flex">
            <h3 className="primary-text">Schedule Crews</h3>
            <div>
              <button
                className={`button button-outline text-primary ${
                  shiftCrews.length ? "" : "disabled"
                }`}
                onClick={this._loadCrewSheetModal}
              >
                Build Crew Sheets
              </button>
              {/*</a>*/}
              <button
                style={{
                  marginLeft: "1em",
                  color: "#2F96B4",
                  borderColor: "#2F96B4",
                }}
                className={`button button-outline text-primary`}
                onClick={() => this.setState({ showShiftModal: true })}
              >
                Create A Shift
              </button>
            </div>
          </div>

          <div className="row">
            <div className="column column-80">
              <div className="flx space_between schedule-options-flex">
                <div className="flx justify-start date-select-line">
                  <div className="flx justify-start date-select-line">
                    <i
                      className={`fas fa-arrow-left fa-pull-left
                                                    ${
                                                      new Moment(
                                                        Date.now()
                                                      ).format("YYYY-MM-DD") ===
                                                      this.state.selectedDate
                                                        ? ""
                                                        : null
                                                    }
                                                `}
                      onClick={() => this._changeDate(false)}
                      title="Previous Day"
                    />
                    <h5>{this.state.selectedDate}</h5>
                    <i
                      className="fas fa-arrow-right fa-pull-right"
                      title="Next Day"
                      onClick={() => this._changeDate(true)}
                    />
                  </div>
                </div>
                <div className="flx justify-end">
                  <div className="override-milligram scheduler-drop-down">
                    {this.state.shiftData.length > 0 ? (
                      <>
                        <div className="mr-3">Shift</div>
                        <Input
                          type={"select"}
                          value={this.props.shift_data.id}
                          options={
                            this.state.shiftData
                              ? this.state.shiftData.map((d, i) => ({
                                  value: d.id,
                                  display:
                                    new Moment(
                                      `${d.shift_date} ${d.start_time}`
                                    ).format("hh:mma") +
                                    " - " +
                                    new Moment(
                                      `${d.shift_date} ${d.end_time}`
                                    ).format("hh:mma"),
                                }))
                              : null
                          }
                          onChange={(val) => this._handleShiftChange(val)}
                        />
                      </>
                    ) : null}
                  </div>
                  <div className="override-milligram scheduler-drop-down">
                    <div className="mr-3">Office</div>
                    <Input
                      type={"select"}
                      value={this.state.focusedOffice}
                      options={
                        this.props.offices
                          ? this.props.offices.map((d, i) => ({
                              value: d.id,
                              display: d.name,
                            }))
                          : null
                      }
                      onChange={(val) => this._handleOfficeChange(val)}
                    />
                  </div>
                </div>
              </div>

              <div className="card wox-card crews-card">
                <div className="">{this._renderCrews()}</div>
              </div>
            </div>
            <div className="column column-20">
              <Tabs
                tabs={[
                  {
                    display: (
                      <i
                        style={{ padding: "0 1em" }}
                        className="fas fa-route"
                      />
                    ),
                    onClick: () =>
                      this.setState({
                        sideBarSelection: "siteroutes",
                        routeFilters: {
                          ...this.state.routeFilters,
                          keywordPersist: this.state.routeFilters.keyword,
                        },
                      }),
                    active: this.state.sideBarSelection === "siteroutes",
                  },
                  {
                    display: (
                      <i
                        style={{ padding: "0 1em" }}
                        className="fas fa-user-clock"
                      />
                    ),
                    onClick: () =>
                      this.setState({
                        sideBarSelection: "canvassers",
                        canvasserFilters: {
                          ...this.state.canvasserFilters,
                          keywordPersist: this.state.canvasserFilters.keyword,
                        },
                      }),
                    active: this.state.sideBarSelection === "canvassers",
                  },
                ]}
                style={{
                  marginBottom: ".8em",
                  justifyContent: "center",
                }}
              />
              <div className="card wox-card crews-card assigned-canvasser-counter primary-text">
                <div>
                  {
                    findCanvassersAssignedToShift(
                      this.state.crews,
                      this.state.shiftId
                    ).length
                  }{" "}
                  Canvassers assigned
                </div>
                {Moment(this.state.selectedDate).isSame(Date.now(), "day") && (
                  <div>
                    {
                      findCheckedInCanvassers(this.state.displayedCanvassers)
                        .length
                    }{" "}
                    Canvassers checked in
                  </div>
                )}
              </div>
              <div className="card wox-card crews-card">
                <div className="sidebar-wrapper">
                  {this.state.sideBarSelection === "siteroutes" && (
                    <FilterDisplay
                      filters={this.state.routeFilters}
                      hideModalButton
                      handleSearchChange={(val) => {
                        debouncedRouteSearch(val);
                      }}
                      handleSortUpdate={(val) => {
                        this.setState({
                          routeFilters: {
                            ...this.state.routeFilters,
                            sortBy: val,
                          },
                        });
                      }}
                      handleSortDirectionChange={() =>
                        this.setState({
                          routeFilters: {
                            ...this.state.routeFilters,
                            sortDsc: !this.state.routeFilters.sortDsc,
                          },
                        })
                      }
                      value={routeValue}
                    />
                  )}
                  {this.state.sideBarSelection === "canvassers" && (
                    <React.Fragment>
                      <CanvasserFilters
                        totalCount={finalList.length}
                        handleFilterUpdate={(statuses, assigned) => {
                          this.setState({
                            displayedCanvasserStatuses: statuses,
                            showAssignedCanvassers: assigned,
                          });
                        }}
                      />
                      <FilterDisplay
                        filters={this.state.canvasserFilters}
                        hideModalButton={true}
                        inlineFilters={finalList}
                        handleSearchChange={(val) => {
                          debouncedCanvasserSearch(val);
                        }}
                        handleSortUpdate={(val) => {
                          console.log("sort update", val);
                          this.setState({
                            canvasserFilters: {
                              ...this.state.canvasserFilters,
                              sortBy: val,
                            },
                          });
                        }}
                        handleSortDirectionChange={() =>
                          this.setState({
                            canvasserFilters: {
                              ...this.state.canvasserFilters,
                              sortDsc: !this.state.canvasserFilters.sortDsc,
                            },
                          })
                        }
                        value={canvasserValue}
                      />
                      <small style={{ float: "right" }}>
                        {finalList.length} canvassers
                      </small>
                    </React.Fragment>
                  )}

                  {this.state.sideBarSelection === "siteroutes"
                    ? this._renderUnassignedRoutes(finalList)
                    : this._renderScheduledCanvassers(finalList)}
                </div>
              </div>
            </div>
          </div>
        </DragDropContext>

        {this.state.crewsheet_modal_show && this._buildCrewSheetModal()}
        {this._renderCreateShiftModal()}

        <FeedbackTile
          text={
            <div>
              <i
                className=" fas fa-asterisk fa-spin"
                style={{ marginRight: "15px" }}
              />
              Loading...
            </div>
          }
          visible={this._isLoading()}
        />
        <FeedbackTile
          text={
            <div>
              <i className="fas fa-check" style={{ marginRight: "15px" }}></i>
              Shift Created
            </div>
          }
          visible={this.state.shiftSuccess}
        />

        {/*use feedback tile icon, text, state*/}
        <FeedbackTile
          text={
            <div>
              <i
                className="fas fa-exclamation-triangle"
                style={{ marginRight: "15px" }}
              />
              {this.state.errMsg}
            </div>
          }
          visible={this._isError()}
          classNames="danger"
        />
      </NavBaseTemplate>
    );
  }
} //end class

const mapStateToProps = (state) => ({
  focusedCampaign: state.session.focusedCampaign,
  siteCanvasses: state.siteCanvasses.data,
  siteRoutes: state.siteRoutes.data,
  siteroutes_loading: state.siteRoutes.loading,
  siteroutes_error: state.siteRoutes.error,
  canvassers: state.canvassers.data,
  canvassers_loading: state.canvassers.loading,
  canvassers_error: state.canvassers.error,
  is_admin: state.permissions.is_admin,
  shift_data: state.crews.shift_data,
  sessionVars: state.session.vars,
  offices: state.offices.data,
});

const mapDispatchToProps = (dispatch) => ({
  setCrewsForRouting: (crews) => dispatch(setCrews(crews)),
  setCrewsShiftData: (data) => dispatch(setCrewsShiftData(data)),
  setSessionVar: (key, value) => dispatch(setSessionVar(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Schedule);
